export const authenticate = (token) => ({
    type: 'AUTHENTICATE',
    payload: {
        token
    }
});

export const setOperatorAction = (operatorId, reload = false) => ({
    type: 'SET_OPERATOR',
    payload: {
        operatorId,
        reload
    }
});

export const verifiedTokenAction = () => ({
    type: 'VERIFIED_TOKEN'
});

export const loadOperatorAction = () => ({
    type: 'LOAD_OPERATOR'
});

export const verifyTokenAction = () => ({
    type: 'VERIFY_TOKEN'
});

export const logoutAction = (clean = false) => ({
    type: 'LOGOUT',
    payload: {
        clean
    }
});




// WEBPACK FOOTER //
// ./src/actions/session.js